<template>
  <transition name="fade">
    <search-template :show="show_filter || !is_mobile" @closeFilter="show_filter = false">
      <template v-slot:top-search>
        <auto-complete @triggerKeywordSearch="searchKeywordsDebounce" :keywords="keywords" :keyword="filters.keyword" :openSearch="openSearch" @triggerSearchSelect="searchWithKeywords" />
      </template>
      <template v-slot:filter-header>
        <ClearFilterLink :clearFilter="clearFilter" :filters="filters.current" :showMobileFilter="showMobileFilter" :is_mobile="is_mobile" />
        <current-filters :filters="[...filters.current]" @removeFilter="removeFilter"></current-filters>
      </template>
      <template v-slot:filter-container>
        <div class="filter-head" v-if="is_mobile">
          <ClearFilterLink :clearFilter="clearFilter" :filters="filters.current" />
          <current-filters :filters="[...filters.current]" @removeFilter="removeFilter"></current-filters>
        </div>
        <app-accordion>
          <template v-slot:title>
            Audience
          </template>
          <template v-slot:content>
            <div class="checkbox-container">
              <checkbox v-for="audience in audiences" :data="audience" :key="audience.term_id" :is_active="[...filters.current]" @onTriggeredClicked="changeFilter" :type="'audiences'">
              </checkbox>
            </div>
          </template>
        </app-accordion>

        <app-accordion class="mb-8">
          <template v-slot:title>
            Topic
          </template>
          <template v-slot:content>
            <div class="checkbox-container">
              <checkbox v-for=" topic  in  topics " :data="topic" :key="topic.term_id" :is_active="[...filters.current]" @onTriggeredClicked="changeFilter" :type="'topics'">
              </checkbox>
            </div>
          </template>
        </app-accordion>

        <app-accordion class="mb-8">
          <template v-slot:title>
            Type
          </template>
          <template v-slot:content>
            <div class="checkbox-container">
              <checkbox v-for=" resource_type  in  resource_types " :data="resource_type" :is_active="[...filters.current]" :key="resource_type.term_id" :type="'resource_types'" @onTriggeredClicked="changeFilter">
              </checkbox>
            </div>
          </template>
        </app-accordion>
      </template>
      <template v-slot:search-container>
        <div class="resource-container" id="id_resources">
          <card v-for=" resource  in  resources " :data="resource" v-if="resources.length"></card>
          <div class="no-result" v-else>No Resource found</div>
        </div>

        <paginate :page-range="3" :page-count="total_pages" v-if="showPagination" :click-handler="nextPage" :prev-class="'prev-items fa-solid fa-chevron-left fa-lg'" :prev-text="''" :next-class="'next-items fa-solid fa-chevron-right fa-lg'" :next-text="''" :container-class="'pagination'">
        </paginate>
      </template>
    </search-template>
  </transition>
</template>

<script>
import axios from "axios"
import SearchTemplate from './SearchTemplate.vue'
import AppAccordion from './components/AppAccordion.vue'
import Checkbox from './components/Checkbox.vue'
import Card from './components/Card.vue'
import Paginate from "vuejs-paginate-next"
import AutoComplete from "./components/AutoComplete.vue"
import CurrentFilters from './components/CurrentFilters.vue'
import ClearFilterLink from './components/ClearFilterLink.vue'

import { debounce } from "lodash"

export default {
  props: {
    filterlists: {
      type: String,
      required: true
    },
  },
  data () {
    return {
      openSearch: false,
      audiences: [],
      topics: [],
      resource_types: [],
      filters: {
        audience: new Set,
        topic: new Set,
        'resource-types': new Set,
        current: new Set,
        keyword: ''
      },
      items_per_page: 1,
      current_page: 1,
      total_pages: 0,
      request_page: 1,
      total_resources: 0,
      showPagination: false,
      resources: [],
      keywords: [],
      show_filter: false,
      is_mobile: false
    }
  },
  components: { AppAccordion, Checkbox, Card, Paginate, AutoComplete, CurrentFilters, SearchTemplate, ClearFilterLink },
  created () {
    const filters = JSON.parse( this.$props.filterlists )

    this.audiences = filters.audience
    this.topics = filters.topics
    this.resource_types = filters.resource_types

    this.checkIfMobile()
  },
  mounted () {
    this.updateURLFilters()
    this.fetch()
    window.addEventListener( "resize", this.checkIfMobile.bind( this ) )
  },
  methods: {
    checkIfMobile () {
      if ( window.innerWidth <= 1200 ) {
        this.is_mobile = true
      } else {
        this.is_mobile = false
        this.show_filter = true
      }
    },
    showMobileFilter () {
      this.show_filter = !this.show_filter
    },
    updateURLFilters () {
      const queryString = window.location.search
      const urlParams = new URLSearchParams( queryString )

      const audience = urlParams.get( 'audiences' )
      const topic = urlParams.get( 'topics' )
      const resource_types = urlParams.get( 'resource_types' )
      const keyword = urlParams.get( 'keyword' )
      const paged = urlParams.get( 'paged' )

      if ( paged ) {
        this.request_page = paged
      }

      if ( audience ) {
        this.filters.audience = new Set( audience?.split( ',' ).map( Number ) )

        this.filters.audience.forEach( element => {
          this.audiences.map( audience => {
            if ( element == audience.term_id ) {
              audience.checked = true
              this.updateCurrentFilter( audience )
            }
          } )
        } )
      }

      if ( topic ) {
        this.filters.topic = new Set( topic?.split( ',' ).map( Number ) )

        this.filters.topic.forEach( element => {
          this.topics.map( topic => {
            if ( element == topic.term_id ) {
              topic.checked = true
              this.updateCurrentFilter( topic )
            }
          } )
        } )
      }

      if ( resource_types ) {
        this.filters[ 'resource-types' ] = new Set( resource_types?.split( ',' ).map( Number ) )

        this.filters[ 'resource-types' ].forEach( element => {
          this.resource_types.map( resource_type => {
            if ( element == resource_type.term_id ) {
              resource_type.checked = true
              this.updateCurrentFilter( resource_type )
            }
          } )
        } )
      }

      if ( keyword ) {
        this.filters.keyword = keyword
      }

    },
    changeFilter ( data ) {
      data.checked ? this.filters[ data.taxonomy ].add( data.term_id ) : this.filters[ data.taxonomy ].delete( data.term_id )
      this.updateCurrentFilter( data )

      this.request_page = 1
      this.showPagination = false
      this.fetch()
    },
    fetch: debounce( function () {
      this.fetchData()
    }, 500 ),
    nextPage ( page ) {
      document.getElementById( 'id_resources' ).scrollIntoView( {
        behavior: 'smooth'
      } )

      this.request_page = page
      this.fetch()
    },
    updateCurrentFilter ( data ) {
      data.checked ? this.filters.current.add( data ) : this.filters.current.delete( data )
    },
    removeFilter ( filter ) {
      this.filters.current.forEach( element => {
        if ( this.filters[ element.taxonomy ].has( filter.term_id ) ) {
          this.filters[ element.taxonomy ].delete( filter.term_id )
        }
      } )

      this.filters.current.delete( filter )

      this.fetch()
    },
    async fetchData () {

      const params = {
        audiences: [ ...this.filters[ 'audience' ] ],
        topics: [ ...this.filters[ 'topic' ] ],
        resource_types: [ ...this.filters[ 'resource-types' ] ],
        keyword: this.filters[ 'keyword' ]
      }

      const res = await axios.get( `/wp-json/bpa/v1/resources`, {
        params: Object.assign( {}, params, {
          paged: this.request_page,
        } )
      } )

      this.current_page = res.current_page
      this.total_pages = res.total_pages
      this.total = res.total_resources
      this.items_per_page = res.items_per_page
      this.resources = res.data
      this.showPagination = this.items_per_page > this.total ? false : true

      let new_params = {}

      Object.keys( params ).forEach( ( key ) => {
        if ( ( ( typeof params[ key ] === 'string' || typeof params[ key ] === 'number' ) && params[ key ] ) || ( Array.isArray( params[ key ] ) && params[ key ].length ) ) {
          new_params[ key ] = params[ key ]
        }
      } )

      new_params ? history.pushState(
        {},
        null,
        window.location.href.split( '?' )[ 0 ] + '?' + new URLSearchParams( new_params ).toString()
      ) : ''
    },

    clearFilter () {
      this.filters = {
        audience: new Set,
        topic: new Set,
        'resource-types': new Set,
        current: new Set
      }

      this.fetch()
    },
    searchKeywordsDebounce: debounce( function ( keyword ) {
      this.searchKeywords( keyword )
    }, 500 ),
    async searchKeywords ( keyword ) {
      this.openSearch = true

      const res = await axios.get( `/wp-json/bpa/v1/resources/keywords`, {
        params: {
          keyword: keyword,
        }
      } )

      this.keywords = res.data
      this.openSearch = false
    },

    searchWithKeywords ( keyword ) {
      this.filters.keyword = keyword
      this.fetch()
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../sass/variables";
@import "../sass/mixins";

.checkbox-container {
  display: grid;
  gap: 8px;
}

.resource-container {
  display: grid;
  gap: 20px;
}

.filter-head {
  position: relative;
  margin-bottom: 24px;

  &::after {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 2px;
    background-color: $colors-secondary;
    content: "";
  }
}
</style>